<template>
  <div class="evaluate-list">
    <div class="filter">
      <div>
        <i
          class="icon-radio"
          :class="{ ative: currentType == 1 }"
          @click="onchange"
        ></i>
        <span class="filter-title" @click="onchange">只看有内容</span>
      </div>
      <ul class="sort-tab">
        <template v-for="{ value, label } in sorts">
          <li
            :key="value"
            :class="{ active: value === rateSortType }"
            @click="sortChange(value, label)"
          >
            {{ `${label}排序` }}
          </li>
        </template>
      </ul>
    </div>
    <HomeList
      ref="list"
      :paramsKey="paramsKey"
      :getListApi="getRatelist"
      :params="homeListParams"
      :pageInfo="pageInfo"
    >
      <template>
        <EvaluateItem
          v-for="item in rateList"
          :key="item.id"
          :info="item"
        ></EvaluateItem>
      </template>
    </HomeList>
  </div>
</template>

<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import EvaluateItem from 'component/platform/homepage/normalUser/evaluateItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    EvaluateItem
  },
  data() {
    return {
      homeListParams: {},
      paramsKey: {
        pageNo: 'page',
        pageSize: 'size',
        listPath: 'list',
        sort_type: 'sort_type'
      },
      pageInfo: {
        page: 2,
        size: 20
      },
      rateSortType: 0,
      sorts: [
        { label: '最新', value: 1 },
        { label: '默认', value: 0 }
      ]
    }
  },
  computed: {
    rateList() {
      return this.$store.getters['homepage/getRateListData'] || []
    },
    currentType() {
      return this.$store.getters['homepage/getCurrentRateType'] || 0
    },
    count() {
      return this.$store.getters['homepage/getRateCount'] || 0
    },
    rateFinish() {
      return this.$store.getters['homepage/rateFinish'] || false
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        teacher_id: this.$route.params.userId,
        type: this.currentType,
        sort_type: this.rateSortType
      }
    })
  },
  methods: {
    getRatelist(params) {
      return this.$store.dispatch('homepage/fetchRatelist', params)
    },
    getRatelistWithParams() {
      this.$set(this.pageInfo, 'page', 1)
      this.$refs.list.listInfo.page = 2
      const params = { ...this.homeListParams, ...this.pageInfo, page: 1 }
      // 可能只有一页
      this.getRatelist(params).then(res => {
        const { code, data } = res
        if (code) return
        this.$refs.list.finished = data.count <= this.pageInfo.size
      })
    },
    onchange() {
      this.$trackEvent('newprofilepages_evaluate_iscontent', {})
      this.$store
        .dispatch('homepage/setCurrentRateType', this.currentType == 1 ? 0 : 1)
        .then(() => {
          this.homeListParams.type = this.currentType
          this.getRatelistWithParams()
        })
    },
    // 排序
    sortChange(type, label) {
      this.$trackEvent('newprofilepages_evaluate_changeorderingrule', {
        orderingrule: `${label}排序`
      })
      this.rateSortType = type
      this.homeListParams.sort_type = type
      this.homeListParams.type = this.currentType
      this.getRatelistWithParams()
    }
  },
  watch: {
    // 兼容处理
    rateFinish(newVal) {
      newVal && (this.$refs.list.finished = newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluate-list {
  .filter {
    display: flex;
    justify-content: space-between;
    padding: 31px 0;
    font-size: 28px;
    line-height: 1;
    .icon-radio {
      display: inline-block;
      width: 30px;
      height: 30px;
      background: url('../../../../images/platform/homepage/icon-radio.png')
        no-repeat center/100% 100%;
      vertical-align: bottom;
      &.ative {
        background: url('../../../../images/platform/homepage/icon-radio-select.png')
          no-repeat center/100% 100%;
      }
    }
    .filter-title {
      margin-left: 10px;
      color: #21252d;
    }
    ul li {
      display: inline-block;
      margin: 0 20px;
      color: #9da3ac;
      &.active {
        color: #21252d;
      }
      &:last-child {
        position: relative;
        &::after {
          content: '|';
          position: absolute;
          left: -21px;
          color: #9da3ac;
        }
      }
    }
  }
}
</style>
